import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MagneticButton } from "./MagneticButton";
import { QuoteForm } from "./QuoteForm";

export function CtaBand() {
  return (
    <section data-testid="cta-band" className="relative py-24 md:py-32 bg-[#224733] text-white overflow-hidden wf-grain">
      <div className="absolute -top-32 -right-32 w-[480px] h-[480px] rounded-full bg-[#62B848]/20 blur-3xl" />
      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <p className="text-[#62B848] font-bold tracking-wide uppercase text-sm mb-4">Ready when you are</p>
          <h2 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-none mb-6">
            Let's sort your roof — properly.
          </h2>
          <p className="text-white/70 text-lg leading-relaxed mb-8 max-w-md">
            Free quotes, honest advice and quality workmanship across Perth. We'll call you back within the hour.
          </p>
          <MagneticButton as="a" href="tel:+61892472962" data-testid="cta-call-btn"
            className="inline-flex items-center gap-2 bg-[#62B848] hover:bg-[#4E9B38] text-white font-bold px-7 py-4 rounded-full transition-colors">
            Call 08 9247 2962 <ArrowRight size={18} />
          </MagneticButton>
        </div>
        <QuoteForm />
      </div>
    </section>
  );
}

export function SectionHeading({ eyebrow, title, sub, light = false, center = false }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl mb-12`}>
      {eyebrow && <p className="text-[#62B848] font-bold tracking-wide uppercase text-sm mb-3">{eyebrow}</p>}
      <h2 className={`font-display font-extrabold heading-up uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-none ${light ? "text-white" : "text-[#1A2421]"}`}>{title}</h2>
      {sub && <p className={`mt-4 text-lg leading-relaxed ${light ? "text-white/60" : "text-[#4A5550]"}`}>{sub}</p>}
    </div>
  );
}
